var map = {
	"./Picture1.png": 6160,
	"./Picture2.png": 2372,
	"./agentposter.jpg": 354,
	"./area.png": 3223,
	"./btn-play-white.png": 7315,
	"./btn-play.png": 2661,
	"./contactimage.webp": 8718,
	"./contactus1.jpg": 8810,
	"./demo/01_home-2.jpg": 4455,
	"./demo/01_home.jpg": 6155,
	"./demo/02_about.jpg": 1370,
	"./demo/03_services.jpg": 749,
	"./demo/04_portfolio-1.jpg": 270,
	"./demo/05_portfolio-2.jpg": 7700,
	"./demo/06_portfolio-3.jpg": 8290,
	"./demo/07_portfolio-single-1.jpg": 3705,
	"./demo/08_portfolio-single-2.jpg": 8161,
	"./demo/09_blog.jpg": 483,
	"./demo/10_blog-single.jpg": 7130,
	"./demo/11_contact-1.jpg": 3299,
	"./demo/12_contact-2.jpg": 2198,
	"./demo/mac.png": 3453,
	"./divider.svg": 4336,
	"./google-marker.png": 6598,
	"./hand.jpg": 3548,
	"./home1.jpg": 9627,
	"./homepage.jpg": 5261,
	"./house.jpg": 1613,
	"./layout.jpg": 4371,
	"./layoutImages/layoutimg1.jpg": 2675,
	"./layoutImages/layoutimg10.png": 3132,
	"./layoutImages/layoutimg11.png": 6323,
	"./layoutImages/layoutimg12.png": 1538,
	"./layoutImages/layoutimg2.jpg": 9050,
	"./layoutImages/layoutimg3.jpg": 8327,
	"./layoutImages/layoutimg4.jpg": 5786,
	"./layoutImages/layoutimg5.jpg": 3319,
	"./layoutImages/layoutimg6.jpeg": 1088,
	"./layoutImages/layoutimg7.jpg": 4243,
	"./layoutImages/layoutimg8.jpg": 2743,
	"./layoutImages/layoutimg9.jpg": 2124,
	"./logo-dark.png": 4226,
	"./logo.png": 1053,
	"./play-button.svg": 1026,
	"./quote-orange.png": 5814,
	"./quotes.png": 3819,
	"./sathesh.jpeg": 403,
	"./sections/279440937_386379206829165_5008929915858305230_n.jpg": 726,
	"./sections/home-top-background.jpg": 6239,
	"./sections/istockphoto-1157695981-612x612.jpg": 1339,
	"./sections/map-village-village-village-city-bohol_895712-1.avif": 3540,
	"./sections/open-plots.jpg": 7378,
	"./sections/section-11.jpg": 6025,
	"./sections/section-4.jpg": 7573,
	"./service.jpg": 4482,
	"./service1.jpeg": 579,
	"./step-arrow.png": 7385,
	"./terms and conditions.pdf": 3840,
	"./terms_and_conditions.pdf": 5153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;